import script from "./ProBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./ProBanner.vue?vue&type=script&setup=true&lang=js"

import "./ProBanner.vue?vue&type=style&index=0&id=07e86cd9&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e86cd9"]])

export default __exports__